import { render, staticRenderFns } from "./cabinet-fl44-card-info-link.vue?vue&type=template&id=c2cf6ca2&"
import script from "./cabinet-fl44-card-info-link.vue?vue&type=script&lang=js&"
export * from "./cabinet-fl44-card-info-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2cf6ca2')) {
      api.createRecord('c2cf6ca2', component.options)
    } else {
      api.reload('c2cf6ca2', component.options)
    }
    module.hot.accept("./cabinet-fl44-card-info-link.vue?vue&type=template&id=c2cf6ca2&", function () {
      api.rerender('c2cf6ca2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/fl44/cards/partials/cabinet-fl44-card-info-link.vue"
export default component.exports